import React, { PureComponent } from 'react';

import { Modal } from 'components/modal';
import ModalClose from 'components/modal/ModalClose';
import { I18n, translate } from 'components/translate';
import { COMMENT_STATUS_ENUM } from 'modules/community/constants';
import PropTypes from 'prop-types';

import './BulkActionModal.scss';

@translate()
class BulkActionModal extends PureComponent {
  static propTypes = {
    t: PropTypes.func,
    label: PropTypes.object,
    toogleModal: PropTypes.func,
    massActionsType: PropTypes.string,
    modal: PropTypes.object,
    commentStatusMassUpdate: PropTypes.func,
    dispatchMacro: PropTypes.func
  };

  createAction = (onClick, title, status = '') => ({ onClick, title, status });

  get actions() {
    const { t, label, commentStatusMassUpdate, dispatchMacro } = this.props;
    const dispatchMass = (label, status) =>
      this.createAction(commentStatusMassUpdate, label, status);

    return {
      approve: dispatchMass(t(label.approve), COMMENT_STATUS_ENUM.APPROVED),
      disapprove: dispatchMass(
        t(label.disapprove),
        COMMENT_STATUS_ENUM.DISAPPROVED
      ),
      spam: dispatchMass(
        t('community.action_message_spam'),
        COMMENT_STATUS_ENUM.SPAM_CONFIRMED
      ),
      dispatchMacro: this.createAction(dispatchMacro, t('community.macro'))
    };
  }

  getConfirmationMessage(title) {
    const { t } = this.props;
    const actionTittle = title.toLowerCase();
    const macroAction = 'macro';

    return actionTittle === macroAction
      ? t('community.modal_macro_message')
      : t('community.confirmation_message', { data: { action: actionTittle } });
  }

  render() {
    const { toogleModal, massActionsType, modal } = this.props;
    const action = this.actions[massActionsType];
    const title = action.title;

    return (
      <Modal onClose={() => toogleModal(modal.close)}>
        <Modal.Header>
          <h5 className="modal-header-warning">
            <I18n label="general.warn_title" />
          </h5>
          <h3 className="modal-title">{title}</h3>
          <ModalClose />
        </Modal.Header>
        <Modal.Body>
          <div className="title__label comment-list__filter__bulk-actions__class-modal">
            {this.getConfirmationMessage(title)}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="hot-button hot-button--primary hot-button--lg"
            onClick={() => action.onClick(action.status, action.title)}
          >
            <I18n label="general.ok" />
          </button>
          <button
            className="hot-button hot-button--lg"
            onClick={() => toogleModal(modal.close)}
          >
            <I18n label="general.cancel" />
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default BulkActionModal;
